import React, { useEffect, useState } from 'react';
import styles from './Calendar.module.scss';
import uploadWhite from '../../../assets/Imagess/upload-white.svg';

import PDFCalendar from './PDFCalendar';
import Loader from '../Loader/Loader';
import Buttons from '../../Atoms/Buttons/Buttons';
import DeletePopup from '../Custom/DeletePopup';
import NoDataComponent from '../Custom/NoDataComponent/NoDataComponent';

function Calendar({
  type,
  year,
  isSuccesCalendarPoster,
  isLoadingCalendarPoster,
  handleUploadPoster,
  handleDelete,
  isDeletingPoster,
  onPosterStateChange,
}) {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const [posterExists, setPosterExists] = useState(null);

  const [posterKey, setPosterKey] = useState(0);

  const openDelete = () => setIsDeleteOpen(true);

  const closeDelete = (force = false) => {
    if (!force && isDeletingPoster) return;
    setIsDeleteOpen(false);
  };

  const handlePosterChange = (exists) => {
    const val = !!exists;
    setPosterExists(val);
    onPosterStateChange?.(val);
  };

  useEffect(() => {
    setPosterExists(null);
    setPosterKey((k) => k + 1);
  }, [type, year]);

  useEffect(() => {
    if (!isSuccesCalendarPoster) return;
    setPosterExists(null);
    setPosterKey((k) => k + 1);
  }, [isSuccesCalendarPoster]);

  const confirmDelete = () => {
    if (year == null || type == null) return;

    handleDelete?.(() => {
      closeDelete(true);
      setPosterExists(false);
      onPosterStateChange?.(false);
      setPosterKey((k) => k + 1);
    });
  };

  return (
    <div className={styles['calendar']}>
      <div className={styles['header']}>
        <div className={styles.actions}>
          <Buttons
            text='تحميل الملصق'
            icon={uploadWhite}
            rounded={true}
            color='rgba(13, 160, 110, 1)'
            handleOnClick={handleUploadPoster}
            style={{ fontFamily: 'BukraMedium' }}
          />

          {posterExists === true && (
            <Buttons
              text='حذف'
              color='#D72222'
              handleOnClick={openDelete}
              rounded
              width={100}
              icon='/icons/delete.svg'
            />
          )}
        </div>

        <p className={styles['title']}>ملصق التقويم</p>
      </div>

      {isLoadingCalendarPoster ? (
        <Loader />
      ) : posterExists === false ? (
        <NoDataComponent text='لم يتم رفع أي ملصق' />
      ) : (
        <PDFCalendar
          key={`${type}-${year}-${posterKey}`}
          type={type}
          year={year}
          isSuccesCalendarPoster={isSuccesCalendarPoster}
          onPosterStateChange={handlePosterChange}
        />
      )}

      {isDeleteOpen && (
        <DeletePopup
          handleOnClose={() => closeDelete(false)}
          title='ملصق التقويم'
          handleDelete={confirmDelete}
          isLoading={!!isDeletingPoster}
          selectedItem={null}
        />
      )}
    </div>
  );
}

export default Calendar;
